import { Action } from '@ngrx/store'
import { StaticContent } from '../models'
import { PaginatedList } from '../libs/infinite-paginator'

export const SET_STATIC_CONTENT_LIST = '[Static Content] Set Static Content List'
export const SET_VIDEO_STATIC_CONTENTS = '[Static Content] Set Video Static Contents'
export const SELECT_STATIC_CONTENT = '[Static Content] Select'

export class SetStaticContentList implements Action {
  readonly type = SET_STATIC_CONTENT_LIST

  constructor(public statcContentList: PaginatedList<StaticContent>) { }
}

export class SetVideoStaticContents implements Action {
  readonly type = SET_VIDEO_STATIC_CONTENTS

  constructor(public videoId: number, public staticContents: StaticContent[]) { }
}

export class SelectStaticContent implements Action {
  readonly type = SELECT_STATIC_CONTENT

  constructor(public staticContent: StaticContent) { }
}

export type All = SetStaticContentList | SelectStaticContent | SetVideoStaticContents



// WEBPACK FOOTER //
// ./src/actions/static-content.ts